import { LocationQueryValue } from 'vue-router';

export function parseQueryBoolean(queryBoolean: LocationQueryValue | LocationQueryValue[]) {
  return queryBoolean === 'true';
}
